module.exports = __webpack_public_path__ + "static/media/UG_Syllabus_2025-26_EXTC_Sem_III-IV.11f4f67d.pdf";